import { render, staticRenderFns } from "./base-component.vue?vue&type=template&id=3978dcb8&scoped=true&"
import script from "./base-component.vue?vue&type=script&lang=js&"
export * from "./base-component.vue?vue&type=script&lang=js&"
import style0 from "./base-component.vue?vue&type=style&index=0&id=3978dcb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3978dcb8",
  null
  
)

export default component.exports